@if (device.isDesktop()) {
  <div class="credit-card-container ">
    <form [formGroup]="form" novalidate>
      <div class="credit-card front">
        <div class="d-flex justify-content-end">
          <img src="assets/creditcard/visa.svg" alt="">
          <img class="ml-2" src="assets/creditcard/mastercard.svg" alt="">
          <img class="ml-2" src="assets/creditcard/maestro.svg" alt="">
          <img class="ml-2" src="assets/creditcard/discover.svg" alt="">
          <img class="ml-2" src="assets/creditcard/americanexpress.svg" alt="">
</div>
        <div class="row mt-4">
          <div class="col-sm">
            <div class="form-group">
              <label class="credit-card-label size-14 mb-0">{{'CreditCard.CardNumber' | translate}}</label>
              <input [formControl]="form.controls['cardNumber']" type="tel"
                mask="0000 0000 0000 0099 9999" class="form-control"
                autocomplete="cc-number" id="cc-number" name="cc-number" />
              <app-validation-message [control]="form.controls['cardNumber']" [error]="'required'">{{
              'General.Field-is-required' | translate }}</app-validation-message>
              <app-validation-message [control]="form.controls['cardNumber']" [error]="'isNotValid'">{{
              'CreditCard.CreditCardNumberNotValidErrorMessage' | translate }}</app-validation-message>
              <app-validation-message [control]="form.controls['cardNumber']" [error]="'isBlocked'">{{
              'CreditCard.CreditCardBrandNotSupportedErrorMessage' | translate }}</app-validation-message>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="credit-card-label size-14 mb-0">{{'CreditCard.CardHolder' | translate}}</label>
              <input [formControl]="form.controls['cardHolder']" type="text" class="form-control"
                [maxLength]="30" autocomplete="cc-name" id="cc-name" name="cc-name" asciiOnly/>
              <app-validation-message [control]="form.controls['cardHolder']" [error]="'required'">{{
              'CreditCard.CardHolderNameRequiredErrorMessage' | translate }}</app-validation-message>
              <app-validation-message [control]="form.controls['cardHolder']" [error]="'invalidCharacters'">{{
              'General.FieldInvalidCharacters' | translate }}</app-validation-message>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="credit-card-label size-14 mb-0">{{'CreditCard.ExpDate' | translate}}</label>
              <input [formControl]="form.controls['expirationDate']" type="text" [mask]="mask.ccExpirationMask" bcMaskGuide
                class="form-control" placeholder="MM/YY" id="expirationDate" autocomplete="cc-exp"
                name="expirationDate" />
              <app-validation-message [control]="form.controls['expirationDate']"
                [error]="'required,pattern'">{{
              'CreditCard.ExpirationDateNotValidErrorMessage' | translate }}</app-validation-message>
              <app-validation-message [control]="form.controls['expirationDate']" [error]="'expiryDateInThePast'">
                {{'CreditCard.ExpiryDateInThePast' | translate }}
              </app-validation-message>
              <app-validation-message [control]="form.controls['expirationDate']"
                [error]="'expiryDateInTheFuture'">
                {{'CreditCard.ExpiryDateInTheFuture' | translate : {maxDate : getMaxExpiryDateFromMonthControl} }}
              </app-validation-message>
            </div>
          </div>
        </div>
      </div>
      <div class="credit-card back">
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label class="credit-card-label size-14 mb-0">
                {{'CreditCard.SecurityCode' | translate}}
                &nbsp;<img class="pb-3-px" src="assets/ic_question_mark.svg"
                (mouseover)='onSecurityCodeOver()' (mouseleave)='onSecurityCodeOut()'>
              </label>
              <div class="bcc-popover-container security-code-popover"
                [attr.data-hidden]="!securityCodePopoverVisible">
                <div class="bcc-popover">
                  <div>
                    {{ 'CreditCard.SecirutyCodeInstructionMessageVisa' | translate }}
                  </div>
                  <img src="assets/card_visa.svg" alt="">
                  <div>
                    {{ 'CreditCard.SecirutyCodeInstructionMessageAmericanExpress' | translate }}
                  </div>
                  <img src="assets/card_american.svg" alt="">
                </div>
              </div>
              <input [formControl]="form.controls['securityCode']" type="tel" [mask]="mask.cvvMask" bcMaskGuide
                class="form-control" autocomplete="cc-csc" id="cc-csc" name="cc-csc" />
              <app-validation-message [control]="form.controls['securityCode']">{{
              'CreditCard.CvcCvvNotValidErrorMessage' | translate }}</app-validation-message>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
} @else {
  <div class="row">
    <div class="col-sm">
      <div class="form-group">
        <label class="size-14 line-height-14">{{'CreditCard.CardNumber' | translate}}</label>
        <input [formControl]="form.controls['cardNumber']" type="tel"
          mask="0000 0000 0000 0099 9999" class="form-control"
          autocomplete="cc-number" id="cc-number" name="cc-number" />
        <app-validation-message [control]="form.controls['cardNumber']" [error]="'required'">{{
        'General.Field-is-required' | translate }}</app-validation-message>
        <app-validation-message [control]="form.controls['cardNumber']" [error]="'isNotValid'">{{
        'CreditCard.CreditCardNumberNotValidErrorMessage' | translate }}</app-validation-message>
        <app-validation-message [control]="form.controls['cardNumber']" [error]="'isBlocked'">{{
        'CreditCard.CreditCardBrandNotSupportedErrorMessage' | translate }}</app-validation-message>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm">
      <div class="form-group">
        <label class="size-14 line-height-14">{{'CreditCard.CardHolder' | translate}}</label>
        <input [formControl]="form.controls['cardHolder']" type="text" class="form-control"
          [maxLength]="30" autocomplete="cc-name" id="cc-name" name="cc-name" asciiOnly/>
        <app-validation-message [control]="form.controls['cardHolder']" [error]="'required'">{{
        'CreditCard.CardHolderNameRequiredErrorMessage' | translate }}</app-validation-message>
        <app-validation-message [control]="form.controls['cardHolder']" [error]="'invalidCharacters'">{{
        'General.FieldInvalidCharacters' | translate }}</app-validation-message>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-sm-6">
      <div class="form-group">
        <label class="size-14 line-height-14">{{'CreditCard.ExpDate' | translate}}</label>
        <div class="row">
          <div class="col-12">
            <input [formControl]="form.controls['expirationDate']" type="text" [mask]="mask.ccExpirationMask" bcMaskGuide
              class="form-control" placeholder="MM/YY"  id="expirationDate" autocomplete="cc-exp"
              name="expirationDate" />
            <app-validation-message [control]="form.controls['expirationDate']"
              [error]="'required,pattern'">{{
            'CreditCard.ExpirationDateNotValidErrorMessage' | translate }}</app-validation-message>
            <app-validation-message [control]="form.controls['expirationDate']" [error]="'expiryDateInThePast'">
              {{'CreditCard.ExpiryDateInThePast' | translate }}
            </app-validation-message>
            <app-validation-message [control]="form.controls['expirationDate']"
              [error]="'expiryDateInTheFuture'">
              {{'CreditCard.ExpiryDateInTheFuture' | translate : {maxDate : getMaxExpiryDateFromMonthControl} }}
            </app-validation-message>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6">
      <div class="form-group">
        <label class="size-14 line-height-14">
          {{'CreditCard.SecurityCode' | translate}}
          &nbsp;<img class="pb-3-px" src="assets/ic_question_mark.svg" (mouseover)='onSecurityCodeOver()'
          (mouseleave)='onSecurityCodeOut()'>
        </label>
        <div class="bcc-popover-container security-code-popover"
          [attr.data-hidden]="!securityCodePopoverVisible">
          <div class="bcc-popover">
            <div>
              {{ 'CreditCard.SecirutyCodeInstructionMessageVisa' | translate }}
            </div>
            <img src="assets/card_visa.svg" alt="">
            <div>
              {{ 'CreditCard.SecirutyCodeInstructionMessageAmericanExpress' | translate }}
            </div>
            <img src="assets/card_american.svg" alt="">
          </div>
        </div>
        <input [formControl]="form.controls['securityCode']" type="tel" [mask]="mask.cvvMask" bcMaskGuide
          class="form-control" autocomplete="cc-csc" id="cc-csc" name="cc-csc" />
        <app-validation-message [control]="form.controls['securityCode']">{{
        'CreditCard.CvcCvvNotValidErrorMessage' | translate }}</app-validation-message>
      </div>
    </div>
  </div>
}
